module.exports = __webpack_public_path__ + "img/type2.c6bde16a.png";